var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

function initSlideMenu() {
    var win = jQuery(window);
    var isWinPhoneDevice = navigator.msPointerEnabled && /MSIE 10.*Touch/.test(navigator.userAgent);
    jQuery('#wrapper').each(function () {
        var holder = jQuery(this);
        var opener = holder.find('a.opener-menu');
        var activeClass = 'opened';
        var animSpeed = 500;
        var menu = holder.find('.slide-nav');
        var overlay = jQuery('<div class="overlay-menu" />').insertBefore(menu);

        opener.bind('click', function (e) {
            e.preventDefault();
            if (!opener.hasClass(activeClass)) {
                showSlide();
            } else {
                hideSlide();
            }
        })

        function onWindowResize() {
            if (win.width() > 767) {
                opener.removeClass(activeClass);
                overlay.hide();
                holder.stop().css({paddingRight: 0, marginLeft: 0});
            } else {
                if (opener.hasClass(activeClass)) {
                    overlay.show();
                    holder.stop().css({paddingRight: menu.width(), marginLeft: -menu.width()});
                }

            }
        }

        function showSlide() {
            opener.addClass(activeClass);
            overlay.show();
            holder.stop().animate({
                paddingRight: menu.width(),
                marginLeft: -menu.width()
            }, {duration: animSpeed});
        }

        function hideSlide() {
            opener.removeClass(activeClass);
            overlay.hide();
            holder.stop().animate({paddingRight: 0, marginLeft: 0}, {duration: animSpeed});
        }

        win.bind('resize orientationchange', onWindowResize);
        overlay.bind(isTouchDevice ? 'touchend' : 'click', function () {
            hideSlide();
        })
        window.mobileMenuShowSlide = showSlide;
    })
}

function initDropDown() {
    jQuery('#nav ul').animDropdown({
        items: 'li',
        drop: '.drop',
        animSpeed: isTouchDevice ? 100 : 700,
        effect: 'slide'
    });
}

;(function ($) {
    $.fn.animDropdown = function (o) {
        // default options
        var options = $.extend({
            hoverClass: 'hover',
            dropClass: 'drop-active',
            items: 'li',
            drop: '>ul',
            delay: isTouchDevice ? 0 : 100,
            animSpeed: isTouchDevice ? 100 : 300,
            effect: 'fade'
        }, o);

        var openEvents, closeEvents, openTriggerFactory, closeTriggerFactory;
        var openSubMenu = function (item, drop, timer) {
            hideAllDropdowns(item);
            item.addClass(options.hoverClass);
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (drop.length && item.hasClass(options.hoverClass)) {
                    item.addClass(options.dropClass);
                    dropdownEffects[options.effect].animate({
                        drop: drop,
                        state: true,
                        speed: options.animSpeed,
                        complete: function () {
                            // callback
                        }
                    });
                }
            }, options.delay);
            item.data('timer', timer);
        }

        var closeSubMenu = function (item, drop, timer) {
            if (!item.hasClass(options.dropClass)) {
                item.removeClass(options.hoverClass);
            }
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (drop.length && item.hasClass(options.dropClass)) {
                    dropdownEffects[options.effect].animate({
                        drop: drop,
                        state: false,
                        speed: options.animSpeed,
                        complete: function () {
                            // callback
                            item.removeClass(options.hoverClass);
                            item.removeClass(options.dropClass);
                        }
                    });
                }
            }, options.delay);
            item.data('timer', timer);
        };


        if (isTouchDevice) {
            openEvents = 'click';
            closeEvents = 'click';

            openTriggerFactory = function (item, drop, timer) {
                return function (e) {
                    e.stopPropagation();
                    var isDropDown = item.children('div').hasClass('has-drop-down') && !$(e.target).closest('.btn-holder').length > 0;
                    if (isDropDown) {
                        e.preventDefault();
                        if (!item.hasClass(options.dropClass)) {
                            openSubMenu(item, drop, timer);
                        } else {
                            closeSubMenu(item, drop, timer);
                        }
                        return false;
                    }
                }
            };
            closeTriggerFactory = function () {

            };

        } else {
            openEvents = 'mouseenter';
            closeEvents = 'mouseleave';
            openTriggerFactory = function (item, drop, timer) {
                return function (e) {
                    if (item.hasClass(options.dropClass)) {
                        return;
                    }
                    openSubMenu(item, drop, timer);
                }
            };
            closeTriggerFactory = function (item, drop, timer) {
                return function (e) {
                    if (!item.hasClass(options.dropClass)) {
                        return;
                    }
                    closeSubMenu(item, drop, timer);
                }
            }
        }


        // hide current level dropdowns
        function hideAllDropdowns(except) {
            var siblings = except.siblings();
            siblings.removeClass(options.hoverClass).each(function () {
                var item = $(this);
                clearTimeout(item.data('timer'));
            });
            siblings.filter('.' + options.dropClass).each(function () {
                var item = jQuery(this).removeClass(options.dropClass);
                if (item.data('drop').length) {
                    dropdownEffects[options.effect].animate({
                        drop: item.data('drop'),
                        state: false,
                        speed: options.animSpeed
                    });
                }
            });
        }

        return this.each(function () {
            // options
            var nav = $(this),
                items = nav.find(options.items);

            items.addClass(options.hoverClass).each(function () {
                var item = $(this), delayTimer;
                var drop = item.find(options.drop);
                item.data('drop', drop);
                if (drop.length) {
                    dropdownEffects[options.effect].prepare({item: item, drop: drop});
                }
                item.on(openEvents, openTriggerFactory(item, drop, delayTimer)).on(closeEvents, closeTriggerFactory(item, drop, delayTimer));
            });

            // hide dropdowns
            items.removeClass(options.hoverClass);
            if (dropdownEffects[options.effect].postProcess) {
                items.each(function () {
                    dropdownEffects[options.effect].postProcess({item: $(this)});
                });
            }

            nav.bind('destroyDropDown', function () {
                items.removeClass(options.dropClass).removeClass(options.hoverClass);
                items.each(function () {
                    $(this).unbind('mouseenter mouseleave');
                    if ($(this).data('drop').parent().hasClass('drop-slide-wrapper')) {
                        $(this).data('drop').removeAttr('style');
                        $(this).data('drop').unwrap();
                    }
                })
            })
        });
    };

    // dropdown effects
    var dropdownEffects = {
        fade: {
            prepare: function (o) {
                o.drop.css({opacity: 0, display: 'none'});
            },
            animate: function (o) {
                o.drop.stop().show().animate({opacity: o.state ? 1 : 0}, {
                    duration: o.speed || 0, complete: function () {
                        if (o.state) {
                            o.drop.css({opacity: ''});
                        } else {
                            o.drop.css({opacity: 0, display: 'none'});
                        }
                        if (typeof o.complete === 'function') {
                            o.complete.call(o.drop);
                        }
                    }
                });
            }
        },
        slide: {
            prepare: function (o) {
                var elementWrap = o.drop.wrap('<div class="drop-slide-wrapper">').show().parent();
                var elementHeight = o.drop.outerHeight(true);
                var elementWidth = o.drop.outerWidth(true);
                elementWrap.css({
                    height: elementHeight,
                    width: elementWidth,
                    position: 'absolute',
                    overflow: 'hidden',
                    top: o.drop.css('top'),
                    left: o.drop.css('left')
                });
                o.drop.css({
                    position: 'static',
                    display: 'block',
                    top: 'auto',
                    left: 'auto'
                });
                o.drop.data('height', elementHeight).data('wrap', elementWrap).css({marginTop: -elementHeight});
            },
            animate: function (o) {
                o.drop.data('wrap').show().css({overflow: 'hidden'});
                o.drop.stop().animate({marginTop: o.state ? 0 : -o.drop.data('height')}, {
                    duration: o.speed || 0, complete: function () {
                        if (o.state) {
                            o.drop.css({marginTop: ''});
                            o.drop.data('wrap').css({overflow: ''});
                        } else {
                            o.drop.data('wrap').css({display: 'none'});
                        }
                        if (typeof o.complete === 'function') {
                            o.complete.call(o.drop);
                        }
                    }
                });
            },
            postProcess: function (o) {
                if (o.item.data('drop').length) {
                    o.item.data('drop').data('wrap').css({display: 'none'});
                }
            }
        }
    };
}(jQuery));
